import React from 'react';

const LOGO_URL = 'https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvcG5n/d0d7060b31cab9e86784ff95ce625624.png';

function Logo({ light = false }) {
  return (
    <img
      src={LOGO_URL}
      alt="Handle My Tech"
      className={light ? 'logo-img light' : 'logo-img'}
      draggable="false"
    />
  );
}

export default Logo;